export const API_URL = `${process.env.BASE_URL}/wp-json/horastro/v1/app/`;
export const GEO_API = `${process.env.BASE_URL}/wp-json/horastro/v1/app/`;

export default API_URL;
